/** intl-ignore */
export default {
  "menu.9001": "用户管理",
  "menu.9003": "角色列表",
  "menu.9004": "状态码管理",
  "menu.9005": "固件版本管理",
  "menu.9008": "企业管理",
  "menu.9013": "菜单管理",
  "menu.215192": "设备管理",
  "menu.217301": "报表管理",
  "menu.264427": "系统管理",
  "menu.421903": "运维管理",
  "menu.435731": "整桩设备",
  "menu.470879": "通信拓扑",
  "menu.518842": "控制拓扑",
  "menu.598633": "日志服务",
  "menu.731278": "检测信息",
  "menu.731748": "平台配置",
  "menu.765783": "设置屏保",
  "menu.781441": "充电桩日志",
  "menu.803041": "充电桩操作日志",
  "menu.900401": "状态码配置",
  "menu.900501": "新增固件",
  "menu.900502": "编辑固件",
  "menu.0101": "充电桩场站管理",
  "menu.010101": "新建场站",
  "menu.010102": "编辑场站",
  "menu.010103": "场站拓扑图",
  "menu.0102": "充电枪管理",
  "menu.010201": "基础信息",
  "menu.0103": "仓库充电桩管理",
  "menu.010301": "仓库充电桩详情",
  "menu.0104": "配电柜管理",
  "menu.0105": "模块管理",
  "menu.010501": "历史设备",
  "menu.010502": "模块信息",
  "menu.010503": "模块信息",
  "menu.0106": "高压设备管理",
  "menu.010601": "高压设备新建",
  "menu.010602": "高压设备编辑",
  "menu.010603": "高压设备详情",
  "menu.0107": "充电桩管理",
  "menu.010701": "新建充电桩",
  "menu.010702": "编辑充电桩",
  "menu.010703": "充电桩详情",
  "menu.0108": "仓库充电枪管理",
  "menu.010801": "仓库充电枪详情",
  "menu.0109": "能源设备管理",
  "menu.010901": "能源设备详情",
  "menu.010902": "配置信息",
  "menu.0110": "FTP映射管理",
  "menu.011001": "新增FTP网络配置",
  "menu.0111": "物料BOM管理",
  "menu.0303": "BI报表",
  "menu.0401": "充电桩故障上报列表",
  "menu.0402": "平台监控充电桩事件列表",
  "menu.040201": "规则详情",
  "menu.040202": "运行数据",
  "menu.040411": "设备拓扑",
  "menu.0405": "能源故障上报列表",
  "menu.0501": "充电订单",
  "menu.0502": "桩连平台日志",
  "menu.0503": "任务管理",
  "menu.050301": "配置修改",
  "menu.050302": "固件升级",
  "menu.050303": "获取最新配置",
  "menu.050304": "修改状态",
  "menu.050305": "批量新增设备",
  "menu.0506": "运维启停订单",
  "menu.0508": "设备操作日志",
  "menu.0509": "桩端日志上报",
  "menu.050901": "新建桩端日志",
  "menu.0510": "充电桩通讯日志",
  "menu.064717": "异常管理",
  "menu.077489": "场站管理",
  "menu.20210706password": "修改密码",
  "menu.20210712createcompany": "新建企业",
  "menu.chargeCourse": "充电数据",
  "menu.newFirmwaredetail": "版本详情",
  "menu.op_platform_0802": "能源设备通讯日志",
  "menu.temperatureMonitoring": "温度监测",
  "menu.269579": "充电枪故障详情",
  "menu.010202": "充电枪详情",
  "menu.523682": "充电枪故障详情",
  "menu.591260": "派单规则管理",
  "menu.356616": "新建派单规则",
  "menu.368060": "编辑派单规则",
  "menu.375990": "查看派单规则",
  "menu.766142": "告警规则管理",
  "menu.965626": "新建告警规则",
  "menu.970782": "编辑告警规则",
  "menu.976120": "查看告警规则",
  "menu.120495": "异常监控",
  "menu.610780": "异常监控详情",
  "menu.550256": "场站监控",
  "menu.433523": "运行数据",
  "menu.371467": "操作日志",
  "menu.467650": "首页",
  "menu.539536": "EUC通信拓扑",
  "menu.396063": "离网拓扑",
  "menu.836220": "版本服务器",
  "menu.EP_593464": "固件详情",
  "menu.EP_698248": "新增固件",
  "menu.EP_714591": "编辑固件",
  "menu.042899": "放电订单",
  "menu.103201": "系统通知",
  "menu.130986": "通知详情",
  "menu.053794": "新增通知",
  "menu.092475": "编辑通知",
  "menu.876953": "eSIM卡管理",
  "menu.OMC_EP_685512": "eSIM卡详情",
  "menu.193529": "消息中心",
  "menu.OMC_EP_731866": "放电数据",
  "menu.933322": "户储设备管理",
  "menu.EP_141226": "户储设备详情",
  "menu.EP_228385": "户储设备配置信息",
  "menu.876198": "户储设备日志",
  "menu.051204": "户储操作日志",
  "menu.767469": "设备安全认证信息",
  "menu.627951": "充电枪上锁失败统计",
  "menu.968604": "设备异常统计",
  "menu.96860401": "充电枪上锁失败统计详情",
  "menu.431117": "辅枪订单",
  "menu.368708": "充电数据",
  "menu.387009": "模块数据",
  "menu.chargerTopology": "充电桩拓扑",
  "menu.085990": "ai日志诊断",
  "menu.aiDiagnosticTaskAdd": "新建AI诊断任务",
  "menu.aiDiagnosticTaskDetail": "AI诊断详情",
  "menu.808649": "设备拓扑图",
  "menu.278064": "导入质保",
  "menu.943846": "统计驾驶舱",
};
